export const useCartRedirect = defineStore("cartRedirect", () => {
  const savedPath = ref<string | undefined>(undefined);

  const savePath = (path: string) => {
    savedPath.value = path;
  };

  const getPath = () => {
    const path = savedPath.value;
    savedPath.value = undefined;

    return path;
  };

  return {
    savePath,
    getPath,
  };
});
